exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".score-score-svg-ufGja{stroke-linecap:round;position:relative;width:84px;height:84px}.score-score-text-40Rr6{-webkit-transform-origin:50% 50%;transform-origin:50% 50%;dominant-baseline:middle;text-anchor:middle;font-family:DIN Alternate;text-align:center;font-size:36px;font-style:normal;font-weight:700;line-height:32px}@-webkit-keyframes score-play-score-3Q6LZ{0%{stroke-dasharray:0 282.6}}@keyframes score-play-score-3Q6LZ{0%{stroke-dasharray:0 282.6}}", ""]);

// Exports
exports.locals = {
	"score-svg": "score-score-svg-ufGja",
	"score-text": "score-score-text-40Rr6",
	"play-score": "score-play-score-3Q6LZ"
};